import config from '../../../application/config/config';
import Fetch from '../../util/core/Fetch';
import { setUserSession } from "../../util/core/Session";
import { runAfterAuthentication } from '../../../application/helpers/afterAuthentication.js'

const urls = {
    authentication: config.endpoints.backend + 'login/auth',
    getUserByToken: config.endpoints.backend + 'core/users/getbytoken',
    getApplicationProfile: config.endpoints.backend + 'core/applicationsprofiles/getById'
}

export const checkLoginPassword = async (login, password) => {
    const params = {
        login: login,
        password: password
    }
    return await Fetch.post(urls.authentication, params);
}

export const authenticate = async (login, password, screenConfig) => {
    const response = await checkLoginPassword(login, password);
    if (response.status) {
        const user = await getUserByToken(response.token);
        setUserSession({
            'user': user,
            'menu': user.permissions,
            'menu_permission': user.menu,
            'menu_mobile': user.menu_mobile,
            'permissions_mobile': user.permissions_mobile,
            'token': response.token,
            'screenConfig': screenConfig,
            'application_instance_id': user.application_instance_id
        });

        await runAfterAuthentication()

        return {
            isAuthenticated: true,
            ...response
        }
    } else {
        return {
            isAuthenticated: false,
            ...response
        }
    }
}


export const getUserByToken = async (token) => {
    const params = {
        token: token
    }
    return await Fetch.post(urls.getUserByToken, params);
}

export const getMenuByApplicationProfileId = async (application_profile_id) => {
    const params = {
        id: application_profile_id
    }
    return await Fetch.post(urls.getApplicationProfile, params);
}

